export const identifySupplierJobsStyle = (theme) => ({
  contentAll: {
    [theme.breakpoints.up("sm")]: {
      height: "calc(100vh - 64px)",
    },
    overflow: "auto",
  },
  root: {
    width: "100%",
  },
  paper: {
    // width: "100%",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    padding: theme.spacing(0),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  table: {
    minWidth: 750,
    "& th": {
      borderBottom: "1px solid rgba(224, 224, 224, 1) !important",
      color: "#404040 !important",
    },
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  title: {
    flex: "1 1 100%",
  },
  tableCellLabel: {
    borderLeft: "1px solid #c1c1c1",
    paddingLeft: "5px",
    margin: "5px 0px 5px",
  },
  chipLabel: {
    "& span": {
      padding: "0px 20px 0px",
    },
  },
  approve: {
    color: "#fff",
    backgroundColor: "green",
    padding: "1px",
    "&:hover": {
      backgroundColor: "green",
      opacity: ".6",
    },
  },
  discard: {
    color: "#fff",
    backgroundColor: "red",
    marginRight: "5px",
    padding: "1px",
    "&:hover": {
      backgroundColor: "red",
      opacity: ".6",
    },
  },
  arrowDropDown: {
    marginRight: "5px",
    minWidth: "auto",
    display: "inline-block",
    margin: 0,
    padding: 0,
  },
  tableCellCheckbox: {
    paddingRight: "0px",
    width: "75px",
  },
  containerCheckboxMenu: {
    display: "inline-block",
    width: "60px",
  },
  checkboxHeader: {
    display: "inline-block",
    padding: "0px",
  },
  buttonStatusOption: {
    display: "inline-flex",
  },
  textCategory: {
    display: "inline-block",
    width: "260px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  text60: {
    display: "inline-block",
    width: "60px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  textCompany: {
    display: "block",
    fontWeight: "bolder",
    fontSize: "14px",
  },
  textLink: {
    display: "block",
    fontSize: "13px",
  },
  textDescription: {
    display: "block",
    fontSize:"13px"
  },
  textSnippet: {
    display: "block",
    fontSize:"13px"
  },
});
 